var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "movements-events-table" },
    [
      _vm.mode === "movements"
        ? _c("MovimentacoesTable", {
            attrs: {
              "sugestoes-por-movimentacao": _vm.sugestoesPorMovimentacao,
              title: _vm.resolvedTitle,
              asset: _vm.asset,
              search: _vm.search,
              items: _vm.movementItems,
              loading: _vm.loading,
              "show-alert-fill-pu": _vm.showAlertFillPu,
              "id-asset-alert-fill-pu": _vm.idAssetAlertFillPu,
              "show-asset-name-column": _vm.showAssetNameColumn,
              "read-only": _vm.readOnly
            },
            on: {
              "revisar-sugestoes": function($event) {
                return _vm.$emit("revisar-sugestoes", $event)
              },
              "open-movimentacoes": function($event) {
                return _vm.$emit("open-movimentacoes", $event)
              },
              "edit-aporte-resgate": _vm.onEditMovement,
              "remove-movimentacao": _vm.onRemoveMovement
            }
          })
        : _vm.mode === "events"
        ? _c("EventosTable", {
            attrs: {
              title: _vm.resolvedTitle,
              asset: _vm.asset,
              search: _vm.search,
              items: _vm.eventItems,
              loading: _vm.loading,
              "show-asset-name-column": _vm.showAssetNameColumn,
              "read-only": _vm.readOnly
            },
            on: {
              "edit-event": _vm.onEditEvent,
              "remove-event": _vm.onRemoveEvent
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "cornerAction",
                  fn: function() {
                    return [_vm._t("cornerAction")]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          })
        : _c("MovementsEventsCombinedTable", {
            attrs: {
              "sugestoes-por-movimentacao": _vm.sugestoesPorMovimentacao,
              title: _vm.resolvedTitle,
              asset: _vm.asset,
              "movement-items": _vm.movementItems || [],
              "event-items": _vm.eventItems || [],
              search: _vm.search,
              loading: _vm.loading,
              "show-alert-fill-pu": _vm.showAlertFillPu,
              "id-asset-alert-fill-pu": _vm.idAssetAlertFillPu,
              "show-asset-name-column": _vm.showAssetNameColumn,
              "read-only": _vm.readOnly
            },
            on: {
              "revisar-sugestoes": function($event) {
                return _vm.$emit("revisar-sugestoes", $event)
              },
              "edit-movement": _vm.onEditMovement,
              "remove-movement": _vm.onRemoveMovement,
              "edit-event": _vm.onEditEvent,
              "remove-event": _vm.onRemoveEvent
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }